module.exports = __webpack_public_path__ + "img/Adient.93c5217c.jpg";